const updates = [
  { date: '2026-08-01', tag: '新片上线', title: '《星际迷航：新纪元》4K 高清版已上线，震撼视效不容错过', hot: true },
  { date: '2026-07-31', tag: '剧集更新', title: '《长安十二时辰》第二季全24集一次性放出', hot: true },
  { date: '2026-07-30', tag: '热门推荐', title: '暑期档动画电影合集上线，涵盖宫崎骏全系列经典', hot: false },
  { date: '2026-07-29', tag: '系统升级', title: '播放器全面升级，新增倍速播放与记忆续播功能', hot: false },
  { date: '2026-07-28', tag: '新片上线', title: '韩国悬疑大片《无声追踪》中文字幕版独家首播', hot: true },
  { date: '2026-07-27', tag: '剧集更新', title: '美剧《暗夜行者》最终季大结局已更新，全集打包上线', hot: false },
  { date: '2026-07-26', tag: '专题上线', title: '「诺兰导演作品」专题页上线，回顾十部经典佳作', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            最新更新
          </h2>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300/60"></div>

          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                {/* Dot */}
                <div className={`absolute left-[11px] md:left-[15px] top-2 w-[9px] h-[9px] rounded-full border-2 ${
                  item.hot
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-100 border-background-400'
                }`}></div>

                {/* Content */}
                <div className="flex-1 bg-background-50/80 rounded-lg p-4 md:p-5 border border-background-200/50 hover:border-background-300/60 transition-colors">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                    <span className="text-foreground-500 text-xs">{item.date}</span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                      item.hot
                        ? 'bg-primary-500/15 text-primary-500'
                        : 'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                    {item.hot && (
                      <span className="text-accent-500 text-xs font-medium">
                        <i className="ri-fire-fill mr-0.5"></i>热门
                      </span>
                    )}
                  </div>
                  <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}